/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizers_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search users to add..." |
*
* @param {Organizers_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const organizers_search_placeholder = /** @type {((inputs?: Organizers_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizers_Search_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des utilisateurs à ajouter...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar usuarios para agregar...")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Buscar usuários para adicionar...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca utenti da aggiungere...")
	return /** @type {LocalizedString} */ ("Search users to add...")
});